import _ from 'lodash';
import { INITIAL_STATE } from '../../constants';

function currentUser() {
	let currentUserState = {};

	try {
		currentUserState.visits = _.isUndefined(window.localStorage.visits) ? INITIAL_STATE.visits : JSON.parse(window.localStorage.visits);
		currentUserState.lastVerification = _.isUndefined(window.localStorage.lastVerification) ? INITIAL_STATE.lastVerification : JSON.parse(window.localStorage.lastVerification);

		currentUserState.activePet = _.isUndefined(window.localStorage.activePet) ? INITIAL_STATE.activePet : JSON.parse(window.localStorage.activePet);
		currentUserState.allPets = _.isUndefined(window.localStorage.allPets) ? INITIAL_STATE.allPets : JSON.parse(window.localStorage.allPets);

		currentUserState.activeGoodies = _.isUndefined(window.localStorage.activeGoodies) ? INITIAL_STATE.activeGoodies : JSON.parse(window.localStorage.activeGoodies);
		currentUserState.collectedGoodies = _.isUndefined(window.localStorage.collectedGoodies) ? INITIAL_STATE.collectedGoodies : JSON.parse(window.localStorage.collectedGoodies);

	} catch (err) {
		currentUserState = {
			...INITIAL_STATE,
		};
	}

	return currentUserState;
}

export default currentUser;



// WEBPACK FOOTER //
// ./src/utils/getStorage/currentUser.js